import { render, staticRenderFns } from "./CheckBag.vue?vue&type=template&id=945b75c6&scoped=true"
import script from "./CheckBag.vue?vue&type=script&lang=js"
export * from "./CheckBag.vue?vue&type=script&lang=js"
import style0 from "./CheckBag.vue?vue&type=style&index=0&id=945b75c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945b75c6",
  null
  
)

export default component.exports